import { Link, useParams } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { chrome } from "@/content/chrome";
import {
  defaultLocale,
  isLocale,
  type Locale,
  localePath,
} from "@/i18n/locales";
import { resolveLegacyPath } from "@/lib/legacy-redirects";

function paramsLocale(params: Record<string, string | undefined>): Locale {
  const value = params.locale;
  return value && isLocale(value) ? value : defaultLocale;
}

export function NotFound() {
  const params = useParams({ strict: false });
  const locale = paramsLocale(params as Record<string, string | undefined>);
  const copy = chrome[locale].notFound;
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const to = resolveLegacyPath(window.location.pathname);
    if (!to) return;
    setRedirecting(true);
    window.location.replace(
      `${to}${window.location.search}${window.location.hash}`,
    );
  }, []);

  if (redirecting) return null;

  return (
    <main className="flex min-h-[70vh] items-center justify-center bg-background px-5 pb-20 pt-36">
      <div className="max-w-lg text-center">
        <img
          src="/icon-ui.webp"
          alt="Vaxy"
          width={192}
          height={192}
          className="mx-auto h-16 w-16 rounded-2xl"
        />
        <p className="mt-8 text-sm font-bold uppercase tracking-widest text-primary">
          404
        </p>
        <h1 className="mt-3 font-heading text-4xl font-bold text-[#1a3a5c]">
          {copy.title}
        </h1>
        <p className="mt-4 text-muted-foreground">{copy.body}</p>
        <Button asChild className="mt-8">
          <Link to={localePath(locale)}>{copy.home}</Link>
        </Button>
      </div>
    </main>
  );
}
